import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import PropTypes from "prop-types";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";
import ScheduleReportList from "./schedule-report-list";
import ReportHeader from "../report-header";
import { requestExportScheduleReportExcel } from "../../../../actions/draftActions";

class ScheduleReportModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filters: {
                fromDate: moment()
                    .startOf("month"),
                toDate: moment()
                    .endOf("month"),
                jobId: null,
                isHistory: false,
                merchandiserId: { value: null, label: "All Merchandisers" },
            },
        };

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect = (name, option) => {
        const filters = Object.assign({}, this.state.filters);
        filters[name] = option;
        this.setState({
            filters
        });
    };

    render() {
        const {
            filters
        } = this.state;

        return (
            <div className="position-relative container">
                <ReportHeader
                    filters={filters}
                    handleSelect={this.handleSelect}
                />
                <ScheduleReportList
                    filters={filters}
                    handleClose={this.props.handleClose}
                    handleSubmit={this.props.requestExportScheduleReportExcel}
                />
            </div>
        );
    }
}

ScheduleReportModal.propTypes = {
    handleClose: PropTypes.func.isRequired
};

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
    requestExportScheduleReportExcel: bindActionCreators(requestExportScheduleReportExcel, dispatch)
});

export default connect(
    null,
    mapStateToDispatch
)(ScheduleReportModal);
